import React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Badge from '@material-ui/core/Badge';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import withStyles from '@material-ui/core/styles/withStyles';
import AccountCircle from '@material-ui/icons/AccountCircle';
import NotificationsIcon from '@material-ui/icons/Notifications';
import MoreIcon from '@material-ui/icons/MoreVert';
import Menus from './Menus';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import Auth from './Login/Auth';
import Grid from '@material-ui/core/Grid/Grid';

const styles = theme => ({
    grow: {
        flexGrow: 1,
    },
    menuButton: {
        marginLeft: -12,
        marginRight: 20,
    },
    title: {
        // display: 'none',
        // [theme.breakpoints.up('sm')]: {
        display: 'block',
        width: 240,
        // background: '#000',
        // },
    },
    sectionDesktop: {
        display: 'none',
        [theme.breakpoints.up('md')]: {
            display: 'flex',
        },
    },
    sectionMobile: {
        display: 'flex',
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
    link: {
        textDecoration: 'none',
        color: '#555'
    },
});

class PrimarySearchAppBar extends React.Component {
    state = {
        anchorEl: null,
        mobileMoreAnchorEl: null,
        paymentAnchorEl: null
    };

    handleProfileMenuOpen = event => {
        this.setState({ anchorEl: event.currentTarget });
    };

    handleMenuClose = () => {
        this.setState({ anchorEl: null });
        this.handleMobileMenuClose();
    };

    handleMobileMenuOpen = event => {
        this.setState({ mobileMoreAnchorEl: event.currentTarget });
    };

    handleMobileMenuClose = () => {
        this.setState({ mobileMoreAnchorEl: null });
    };

    togglePaymentMenu = event =>{
        this.setState({
            paymentAnchorEl: this.state.paymentAnchorEl === null ? event.currentTarget : null
        })
    }

    makeLogout = () => {
        this.setState({ anchorEl: null });
        Auth.logout(this.props.history);
    };
    render() {

        const { anchorEl, mobileMoreAnchorEl, paymentAnchorEl } = this.state;
        const { classes, loggedIn } = this.props;

        const isMenuOpen = Boolean(anchorEl);
        const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
        const isPaymentMenuOpen = Boolean(paymentAnchorEl);

        const renderMenu = (
            <Menu
                anchorEl={anchorEl}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                open={isMenuOpen}
                onClose={this.handleMenuClose}
            >
                <MenuItem>Profile</MenuItem>
                <MenuItem onClick={this.makeLogout}>Logout</MenuItem>
            </Menu>
        );

        const renderMobileMenu = (
            <Menu
                anchorEl={mobileMoreAnchorEl}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                open={isMobileMenuOpen}
                onClose={this.handleMobileMenuClose}
            >
                <MenuItem onClick={this.handleProfileMenuOpen}>
                    <IconButton color="inherit">
                        <AccountCircle />
                    </IconButton>
                    <p>Profile</p>
                </MenuItem>
            </Menu>
        );
        const PaymentMenu = (
            <Menu 
                anchorEl={paymentAnchorEl}
                transformOrigin={{vertical: 'bottom', 'horizontal': 'right'}}
                open={isPaymentMenuOpen}
                onClose={this.togglePaymentMenu}
                >
                    <MenuItem>
                        <Link className={classes.link} onClick={this.togglePaymentMenu} to="/Payment">Commision</Link>
                    </MenuItem>
                    <MenuItem>
                        <Link className={classes.link} onClick={this.togglePaymentMenu} to="/VwInvestPay">Investor</Link>
                    </MenuItem>
                </Menu>
        )

        return (
            <AppBar position="static">
                <Toolbar>
                    <Typography
                        className={classes.title}
                        variant="h6"
                        color="inherit"
                        noWrap
                    >
                        Shivkala FD
                    </Typography>
                    {loggedIn && (
                        <Grid container>
                            <Menus action1={this.togglePaymentMenu}/>

                            <div className={classes.grow} />

                            <Notif notifNumber="0" />

                            <div className={classes.sectionDesktop}>
                                <IconButton
                                    onClick={this.handleProfileMenuOpen}
                                    color="inherit"
                                >
                                    <AccountCircle />
                                </IconButton>
                            </div>

                            <div className={classes.sectionMobile}>
                                <IconButton
                                    onClick={this.handleMobileMenuOpen}
                                    color="inherit"
                                >
                                    <MoreIcon />
                                </IconButton>
                            </div>
                        </Grid>
                    )}
                </Toolbar>
                {renderMenu}
                {renderMobileMenu}
                {PaymentMenu}
            </AppBar>
        );
    }
}

PrimarySearchAppBar.propTypes = {
    classes: PropTypes.object.isRequired,
};

const map = state => {
    return {
        loggedIn: state.loggedIn,
        loggedUname: state.loggedUname,
    };
};

export default connect(map)(
    withStyles(styles)(withRouter(PrimarySearchAppBar))
);
// export default withStyles(styles)(withRouter(PrimarySearchAppBar));

const Notif = ({ notifNumber }) => (
    <IconButton color="inherit">
        <Badge badgeContent={notifNumber} color="secondary">
            <NotificationsIcon />
        </Badge>
    </IconButton>
);

